/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "eu-west-3",
  aws_appsync_graphqlEndpoint:
    "https://kdxls7rpp5dxvj6aqhx3sruqpu.appsync-api.eu-west-3.amazonaws.com/graphql",
  aws_appsync_region: "eu-west-3",
  aws_appsync_authenticationType: "API_KEY",
  aws_appsync_apiKey: "da2-6r4imgtc3fdmjkb3gucaiarvmy",
  aws_cognito_identity_pool_id:
    "eu-west-3:5712d725-9c5a-4862-94be-1c95d73622f2",
  aws_cognito_region: "eu-west-3",
  aws_user_pools_id: "eu-west-3_gMgnL2GTi",
  aws_user_pools_web_client_id: "7nedlq1f3h7m8fisnfsf0h2to3",
  oauth: {},
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["PHONE_NUMBER"],
};

export default awsmobile;
